import { Form, Formik } from "formik";
import { Button } from "../ui/Button";
import { TextField } from "../ui";
import { ToggleButton } from "../ui/Toggle/ToggleButton";
import * as Yup from 'yup';
import { UploadFile } from "../ui/uploadFile";

export const ServiceFields = ({ requiredFields, setFormStep, handleFieldsSubmit }) => {

    const validationObject = Yup.object().shape(
        requiredFields.reduce((result, item) => {
            if (item === 'tyreChange') {
                result[item] =  Yup.object({
                    frontTyreWidth:  Yup.number().min(100,'Η τιμή πρέπει να είναι μεγαλύτερη από 100').max(999,'Η τιμή πρέπει να είναι μικρότερη από 1000').required('Υποχρεωτικό πεδίο'),
                    frontTyreHeight:  Yup.number().min(10,'Η τιμή πρέπει να είναι μεγαλύτερη από 10').max(99,'Η τιμή πρέπει να είναι μικρότερη από 100').required('Υποχρεωτικό πεδίο'),
                    frontTyreDiameter:  Yup.number().min(10,'Η τιμή πρέπει να είναι μεγαλύτερη από 10').max(99,'Η τιμή πρέπει να είναι μικρότερη από 100').required('Υποχρεωτικό πεδίο'),
                    rearSameAsFront:  Yup.boolean(),
                    rearTyreWidth: Yup.number().when("rearSameAsFront", {
                        is: false,
                        then: schema => schema.required('Υποχρεωτικό πεδίο'),
                        otherwise: schema => schema.optional(),
                    }),
                    rearTyreHeight:  Yup.number().when('rearSameAsFront', {
                        is: false,
                        then: schema => schema.required('Υποχρεωτικό πεδίο'),
                        otherwise: schema => schema.optional(),
                        }),
                    rearTyreDiameter:  Yup.number().when('rearSameAsFront', {
                        is: false,
                        then: schema => schema.required('Υποχρεωτικό πεδίο'),
                        otherwise: schema => schema.optional(),
                        }),
                }).required('')
            }
            if (item === 'bodyWork') {
                result[item] = Yup.string().required('Υποχρεωτικό πεδίο');
            }
            else if (item === 'bodyWorkPhotos') {
                result[item] =  Yup.array().of(Yup.mixed()).length(3, 'Θα πρέπει να ανεβάσεις 3 φωτογραφίες.');
            } else if (item === 'serviceLightIndicator') {
                result[item] =  Yup.boolean().oneOf([true]).required('Η ένδειξη service πρέπει να είναι αναμμένη για να κλείσεις ραντεβού.')
            }
            return result;
        }, {})
    )

    return (
        <Formik 
            initialValues={requiredFields.reduce((result, item) => {
                if (item === 'tyreChange') {
                    result[item] = {
                        frontTyreWidth: '',
                        frontTyreHeight: '',
                        frontTyreDiameter: '',
                        tyreRunFlat: false,
                        rearSameAsFront: true,
                        rearTyreWidth: '',
                        rearTyreHeight: '',
                        rearTyreDiameter: ''
                        }
                }
                else if (item === 'bodyWork') {
                    result[item] = ''
                }
                else if (item === 'bodyWorkPhotos') {
                    result[item] = [null,null,null]
                } else if (item === 'additionalComments') {
                    result[item] = ''
                } else {
                    result[item] = false
                }
                return result;
            },{})}
          isInitialValid={false}
            validationSchema={validationObject}
            validateOnMount
          onSubmit={async (values) => {
            handleFieldsSubmit(values)
          }}>
            {({ errors, touched, values, setFieldValue, isValid, validateForm, ...props }) => {

                const handleUpload = (mode,file,index) => {
                    let updateArray = [...values.bodyWorkPhotos];
                    if(mode === 'upload'){
                        updateArray[index] = file;
                    } else {
                        updateArray[index] = null;
                    }
                    setFieldValue('bodyWorkPhotos', updateArray)
                }

                return (
                    <Form className={'flex flex-col gap-10 relative mb-5'}>
                        <div className="max-lg:w-full max-lg:my-5 order-last lg:right-0 lg:absolute flex max-lg:flex-col-reverse max-lg:bottom-0 gap-4 lg:gap-10 lg:-top-[60px]">
                            <Button className={'max-lg:mx-5 border border-[#A5A5A5] py-3 px-10 rounded-[6px] text-primary-button'} onClick={()=> {setFormStep(0)}}>Ακύρωση</Button>
                            <Button type="submit" disabled={Object.keys(errors).length !==0} className={'max-lg:mx-5 disabled:bg-[#A5A5A5] rounded-[6px] bg-[#D4002A] py-3 px-10 text-primary-button text-white'}>Επόμενο</Button>
                        </div>
                        {requiredFields.map(item => {
                            if (item === 'tyreChange') {
                                return (
                                    <div className="lg:bg-white rounded-[20px] lg:p-6 justify-between flex flex-col gap-5">
                                        <h4>Αλλαγή Ελαστικών</h4>
                                        <div className="grid lg:grid-cols-2 gap-5">
                                            <TextField error={errors?.tyreChange?.frontTyreWidth} type={'number'} step={5} min={100} max={999} label={'Πλάτος πέλματος ελαστικών εμπρόσθιων τροχών:'}  onChange={(e) => setFieldValue('tyreChange.frontTyreWidth', e.target.value)} placeholder={'235'} />
                                            <TextField error={errors?.tyreChange?.frontTyreHeight} type={'number'} min={10} max={99} label={"Ύψος/προφίλ ελαστικών εμπρόσθιων τροχών:"} step={5}  onChange={(e) => setFieldValue('tyreChange.frontTyreHeight', e.target.value)} placeholder={'55'} />
                                            <TextField error={errors?.tyreChange?.frontTyreDiameter} type={'number'} min={10} max={99} label={"Εσωτερική διάμετρος ελαστικών εμπρόσθιων τροχών:"} step={1} placeholder="17" onChange={(e) => setFieldValue('tyreChange.frontTyreDiameter', e.target.value)} />
                                            {!values.tyreChange.rearSameAsFront &&
                                                <>
                                                <TextField type={'number'} min={100} max={999} label="Πλάτος πέλματος ελαστικών οπίσθιων τροχών:" step={5} placeholder= "235"  error={errors?.tyreChange?.rearTyreWidth} onChange={(e) => setFieldValue('tyreChange.rearTyreWidth', e.target.value)}/>
                                                <TextField type={'number'} min={10} max={99} label="Ύψος/προφίλ ελαστικών οπίσθιων τροχών:" step={5} placeholder= "55"  error={errors?.tyreChange?.rearTyreHeight} onChange={(e) => setFieldValue('tyreChange.rearTyreHeight', e.target.value)}/>
                                                <TextField type={'number'} min={10} max={99} label="Εσωτερική διάμετρος ελαστικών οπίσθιων τροχών:" step={1} placeholder= "17" error={errors?.tyreChange?.rearTyreDiameter} onChange={(e) => setFieldValue('tyreChange.rearTyreDiameter', e.target.value)}/>                                           
                                                </>
                                            }
                                        </div>
                                        <div className="flex gap-2 items-center">
                                                <ToggleButton onCheckedChange={(value) => setFieldValue('tyreChange.tyreRunFlat', value)} />
                                                <p>Runflat ελαστικά</p>
                                            </div>
                                        <div className="flex gap-2 items-center">
                                            <ToggleButton checked={values.tyreChange.rearSameAsFront} onCheckedChange={(value) => {
                                                if (!value) {
                                                    setFieldValue('tyreChange.rearTyreWidth', '');
                                                    setFieldValue('tyreChange.rearTyreHeight', '');
                                                    setFieldValue('tyreChange.rearTyreDiameter', '');
                                                }
                                                setFieldValue('tyreChange.rearSameAsFront', value)
                                            }} />
                                            <p>Ίδια ελαστικά στους εμπρόσθιους και τους οπίσθιους τροχούς</p>
                                        </div>
                                    </div>
                                )
                            } else if (item === 'serviceLightIndicator') {
                                return (
                                    <div className="lg:bg-white rounded-[20px] lg:p-6 justify-between flex items-center">
                                        <h4>Ετήσιο ή έκτακτο service </h4>
                                        <div className="flex gap-2 items-center">
                                            <p className="text-body">Ένδειξη service αναμμένη</p>
                                            <ToggleButton onCheckedChange={(value) => setFieldValue('serviceLightIndicator', value)} />
                                        </div>
                                    </div>
                               )
                            }
                            else if (item === 'bodyWork') {
                                return (
                                    <div className="lg:bg-white rounded-[20px] lg:p-6">
                                        <TextField error={errors?.bodyWork} type={'textarea'} label={'Περίγραψε τις εργασίες φανοποιίας που επιθυμείς να πραγματοποιηθούν στο αυτοκίνητό σου.'} onChange={(e) => setFieldValue(item, e.target.value)} placeholder={''} />
                                    </div>
                                )   
                            }
                            else if (item === 'bodyWorkPhotos') {
                                return (
                                    <div className="lg:bg-white lg:p-6 rounded-[20px] gap-2 flex flex-col">
                                        <h4>Φανοποιία</h4>
                                        <p className="text-label">Φωτογραφίες</p>
                                        <div className="grid grid-cols-3 gap-4 w-full">
                                            <UploadFile prevFile={values.bodyWorkPhotos[0]} allowedTypes={['tiff','jpeg','gif','bmp','png','jpeg','jpg','webp','tiff','pjpeg','avif']} canDelete={false} onFileChange={(mode, file) => { handleUpload(mode, file, 0) }} itemIndex={0} maxFiles={1} />
                                            <UploadFile prevFile={values.bodyWorkPhotos[1]} allowedTypes={['tiff','jpeg','gif','bmp','png','jpeg','jpg','webp','tiff','pjpeg','avif']} canDelete={false} onFileChange={(mode, file) => { handleUpload(mode, file, 1) }} itemIndex={1} maxFiles={1} />
                                            <UploadFile prevFile={values.bodyWorkPhotos[2]} allowedTypes={['tiff','jpeg','gif','bmp','png','jpeg','jpg','webp','tiff','pjpeg','avif']} canDelete={false} onFileChange={(mode, file) => { handleUpload(mode, file, 2) }} itemIndex={2} maxFiles={1} />
                                        </div>
                                        {errors.bodyWorkPhotos && <p className="text-primary text-label">Ανέβασε 3 φωτογραφίες</p>}
                                    </div>
                                )
                                
                            } else if (item === 'additionalComments') {
                                return (
                                    <div className="lg:bg-white rounded-[20px] lg:p-6">
                                        <TextField type={'textarea'} label={'Συμπλήρωσε οποιαδήποτε επιπλέον πληροφορία χρειάζεται να γνωρίζουμε.'} onChange={(e) => setFieldValue(item, e.target.value)} placeholder={''} />
                                    </div>
                                )  
                            } else {
                                return (
                                    <div className="lg:bg-white rounded-[20px] justify-end lg:p-6 lg:justify-between flex max-lg:flex-row-reverse max-lg:gap-4">
                                        <div className="lg:w-9/12 flex flex-col gap-2">
                                            <h4>Υπηρεσία Pick-Up & Delivery</h4>
                                            <div>
                                                <p className="text-body">Παραλαβή και επιστροφή του αυτοκινήτου στον χώρο σου.</p>
                                                <p className="text-body">  Κόστος: 45€ με ΦΠΑ</p>
                                            </div>
                                        </div>
                                        <ToggleButton onCheckedChange={(value) => setFieldValue('wantPickupDelivery', value)}/>
                                    </div>
                               )
                            }
                        })}    
                </Form>
       )}}
        </Formik>
    )
}